import { Row } from 'react-bootstrap';
import Main from '../components/Layout/Main';
import Sidebar from '../components/Layout/Sidebar';
import Ansprechpartner from '../components/Sidebar/Ansprechpartner';
import PageHeader from '../components/PageHeader';


function Impressum() {
    return (
        <div>
            <PageHeader title="Impressum" />
            <Row className='page-main'>
                <Main>
                <p style={{paddingTop: "6px"}}>Heinrich Heiden GmbH & Co. KG<br/>
Schüllsmühle 14<br/>
52353 Düren</p>


<p><b>Telefon:</b> +49 2421 9875 0<br/>
<b>Telefax:</b> +49 2421 880689<br/>
<b>E-Mail:</b> <a href="mailto:info@heinrich-heiden.de">info@heinrich-heiden.de</a><br/>
</p>

<p><b>Geschäftsführerin:</b><br/>
Claudia Herper
</p>

<p>
<b>Handelsregister:</b> Düren, HRA 1124<br/>
<b>Umsatzsteuer-ID:</b> DE 122283887
</p>

<br/>
<p style={{paddingBottom: "6px"}}>
Rechtshinweis:<br/>
<small>Die Firma Heinrich Heiden, vertreten durch ihre Geschäftsführerin Claudia Herper, erklärt gemäß dem Teledienstgesetz ausdrücklich für ihren gesamten Internetauftritt, dass sie keinerlei Einfluß auf den Inhalt und die Gestaltung der verlinkten Seiten (Internet-Präsentationen) hat und diese nur zu Informationszwecken anbietet.</small>
</p>
                </Main>
                
               
            </Row>
        </div>
      );
}

export default Impressum;